import { render } from "./add-edit-signatory-modal.html?vue&type=template&id=09ab4795&scoped=true&ts=true&external"
import script from "./add-edit-signatory-modal.ts?vue&type=script&lang=ts&external"
export * from "./add-edit-signatory-modal.ts?vue&type=script&lang=ts&external"

import "./add-edit-signatory-modal.scss?vue&type=style&index=0&id=09ab4795&scoped=true&lang=scss&external"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-09ab4795"]])

export default __exports__